var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreditcardArt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 5,
    fill: "#FFF8E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 10.6667H9.99999C9.26361 10.6667 8.66666 11.2636 8.66666 12V20C8.66666 20.7364 9.26361 21.3333 9.99999 21.3333H22C22.7364 21.3333 23.3333 20.7364 23.3333 20V12C23.3333 11.2636 22.7364 10.6667 22 10.6667Z",
    stroke: "#FABC2F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66666 14.6667H23.3333",
    stroke: "#FABC2F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditcardArt);
export default __webpack_public_path__ + "static/media/creditcardArt.32d1ecd88d1d418a17bc5f9bed965942.svg";
export { ForwardRef as ReactComponent };